/* eslint-disable react/destructuring-assignment */
import { logError } from '@core/Utils'
import React from 'react'

export class TrendingBetTileErrorBoundary<
  TP extends { children?: React.ReactNode },
> extends React.Component<TP, { hasError: boolean }> {
  constructor(props: TP) {
    super(props)
    this.state = { hasError: false }
  }

  public componentDidCatch(error: { toString: () => string } /*, info*/) {
    logError(`TrendingBetTile render error: ${error.toString()}`, true)
    this.setState({
      hasError: true,
    })
  }

  public render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}
